<template>
  <v-carousel class="transparent-carousel" hide-delimiters :hide-controls="dataSet.length <= 1" height="308px" :cycle="true">
    <v-carousel-item v-for="(itms, index) in dataSet" :key="index">
      <v-layout row wrap>
        <v-flex v-for="item in itms" :key="item.name" xs6>
          <ValueCard :title="item.name"
            :value="cardValue[item.name].value"
            :unit="cardValue[item.name].unit">
          </ValueCard>
        </v-flex>
      </v-layout>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mixin } from '@/util/mixin/index'

export default {
  mixins: [mixin],
  components: {
    ValueCard: () => import('@/components/utility/ValueCard')
  },
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  computed: {
    dataSet() {
      const clonedItems = _.cloneDeep(this.items)
      return this.groupArray(clonedItems, 6)
    },
    cardValue() {
      const tempObj = {}
      this.items.forEach(item => {
        tempObj[item.name] = {}
        if (item.value === 'No Data' || item.value === '-') {
          tempObj[item.name]['unit'] = ''
        } else {
          if (item.name.includes('YTD')) {
            tempObj[item.name]['unit'] = this.unit(item.value + this.todayGen(item.name))
          } else {
            if (item.name.includes('Gen')) {
              tempObj[item.name]['unit'] = this.unit(item.value)
            } else {
              tempObj[item.name]['unit'] = item.unit
            }
          }
        }

        if (item.value !== 'No Data' && item.value !== '-') {
          if (item.name.includes('YTD')) {
            tempObj[item.name]['value'] = this.value(parseFloat(item.value) + this.todayGen(item.name))
          } else {
            if (item.name.toLowerCase().includes('gen')) {
              tempObj[item.name]['value'] = this.value(item.value)
            } else {
              if (item.value !== null) {
                tempObj[item.name]['value'] = item.value
              } else {
                tempObj[item.name]['value'] = 'No Data'
              }
            }
          }
        } else {
          tempObj[item.name]['value'] = item.value
        }
      })

      return tempObj
    }
  },
  methods: {
    todayGen(component) {
      let param
      if (component === 'INV Gen (MTD)' || component === 'INV Gen (YTD)') {
        param = 'INV Gen (Today)'
      } else if (component === 'EM Gen (MTD)' || component === 'EM Gen (YTD)') {
        param = 'EM Gen (Today)'
      } else if (component === 'MFM Gen (MTD)' || component === 'MFM Gen (YTD)') {
        param = 'MFM Gen (Today)'
      }

      return this.items.reduce((acc, item) => {
        return (
          acc + (item.name === param ? (item.value !== null ? parseFloat(item.value) : 0) : 0)
        )
      }, 0)
    },
    value(data) {
      let tempData = null
      if (data !== null) {
        if (data > 99999999) {
          tempData = (data / 1000000).toFixed(3)
        } else if (data > 999999) {
          tempData = (data / 1000).toFixed(3)
        } else {
          tempData = Math.round(data)
        }
      } else {
        tempData = 0
      }

      return tempData
    },
    unit(data) {
      if (data > 99999999) {
        return 'GWh'
      } if (data > 999999) {
        return 'MWh'
      } else {
        return 'kWh'
      }
    },
    groupArray(array, groupSize) {
      const groupedArray = [];
      for (let i = 0; i < array.length; i += groupSize) {
        groupedArray.push(array.slice(i, i + groupSize));
      }
      return groupedArray;
    }
  }
}
</script>

<style scoped>
  @import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");

  * {
    font-family: "Poppins", sans-serif;
  }

  .transparent-carousel {
    border: none;
    box-shadow: none;
  }
</style>
